"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFcmTokenResponseSchema = exports.createFcmTokenBodySchema = void 0;
const zod_1 = require("zod");
const api_schemas_1 = require("../base/api.schemas");
const profile_schemas_1 = require("./profile.schemas");
// ============================================
// FCM TOKEN REGISTRATION API SCHEMAS
// ============================================
// POST /me/fcm-tokens - Body
exports.createFcmTokenBodySchema = zod_1.z.object({
    fcmToken: zod_1.z.string().min(1, 'FCM token is required'),
    deviceType: profile_schemas_1.DeviceTypeSchema,
});
// POST /me/fcm-tokens - Response
exports.createFcmTokenResponseSchema = (0, api_schemas_1.dataResponseSchema)(zod_1.z.object({
    tokenId: zod_1.z.number().int().positive(),
    registered: zod_1.z.boolean(),
}));
